import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function ProcesVerbauxCaisse() {
  const [pvs, setPvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [filterStatut, setFilterStatut] = useState('');
  const [formData, setFormData] = useState({
    titre: '',
    date_reunion: new Date().toISOString().split('T')[0],
    date_redaction: new Date().toISOString().split('T')[0],
    participants_presents: [],
    resume: '',
    decisions: [],
    observations_caisse: '',
    observations_dg: '',
    statut: 'brouillon'
  });
  const [editingId, setEditingId] = useState(null);
  const [selectedPv, setSelectedPv] = useState(null);

  useEffect(() => {
    loadPVs();
  }, []);

  const loadPVs = async () => {
    try {
      setLoading(true);
      const response = await api.procesVerbaux.getAll();
      setPvs(response.pvs || []);
    } catch (error) {
      console.error('Erreur chargement PV:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      if (!formData.titre || !formData.date_reunion) {
        alert('Veuillez remplir tous les champs obligatoires');
        return;
      }

      // Mapper observations_caisse vers observations_rh pour la compatibilité backend
      const dataToSend = {
        ...formData,
        observations_rh: formData.observations_caisse,
      };

      if (editingId) {
        await api.procesVerbaux.update(editingId, dataToSend);
      } else {
        await api.procesVerbaux.create(dataToSend);
      }

      await loadPVs();
      handleCloseModal();
    } catch (error) {
      console.error('Erreur sauvegarde PV:', error);
      alert('Erreur lors de la sauvegarde');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce PV ?')) return;
    try {
      await api.procesVerbaux.delete(id);
      await loadPVs();
    } catch (error) {
      console.error('Erreur suppression PV:', error);
    }
  };

  const handleValider = async (id) => {
    if (!window.confirm('Valider ce PV ? Il ne pourra plus être modifié.')) return;
    try {
      await api.procesVerbaux.valider(id);
      await loadPVs();
    } catch (error) {
      console.error('Erreur validation PV:', error);
    }
  };

  const handleOpenModal = (pv = null) => {
    if (pv) {
      setEditingId(pv.id);
      setFormData({
        titre: pv.titre,
        date_reunion: pv.date_reunion,
        date_redaction: pv.date_redaction,
        participants_presents: pv.participants_presents || [],
        resume: pv.resume || '',
        decisions: pv.decisions || [],
        observations_caisse: pv.observations_rh || '', // Mapper observations_rh vers observations_caisse
        observations_dg: pv.observations_dg || '',
        statut: pv.statut
      });
    } else {
      setEditingId(null);
      setFormData({
        titre: '',
        date_reunion: new Date().toISOString().split('T')[0],
        date_redaction: new Date().toISOString().split('T')[0],
        participants_presents: [],
        resume: '',
        decisions: [],
        observations_caisse: '',
        observations_dg: '',
        statut: 'brouillon'
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
  };

  const fmtDate = (dateStr) => {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    return d.toLocaleDateString('fr-FR');
  };

  const getStatutBadge = (statut) => {
    const badges = {
      brouillon: { color: '#ff9800', label: 'Brouillon' },
      valide: { color: '#4caf50', label: 'Validé' },
      diffuse: { color: '#2196f3', label: 'Diffusé' }
    };
    const badge = badges[statut] || badges.brouillon;
    return (
      <span style={{
        background: `${badge.color}22`,
        border: `1px solid ${badge.color}44`,
        color: badge.color,
        padding: '3px 10px',
        borderRadius: 12,
        fontSize: 10,
        fontWeight: 600
      }}>
        {badge.label}
      </span>
    );
  };

  const pvsFiltres = filterStatut 
    ? pvs.filter(pv => pv.statut === filterStatut)
    : pvs;

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
        <div>
          <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#fff', marginBottom: 4 }}>
            📋 Procès-Verbaux Secrétariat - Caisse & DG
          </h2>
          <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.42)' }}>
            Gestion des PV avec observations du Chef Département Caisse et du DG
          </p>
        </div>
        <button 
          onClick={() => handleOpenModal()}
          style={{
            background: 'linear-gradient(135deg,#C9A84C,#8a6028)',
            border: 'none',
            borderRadius: 7,
            padding: '8px 16px',
            color: 'white',
            fontSize: 11,
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          + Nouveau PV
        </button>
      </div>

      {/* Filtres */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['', 'brouillon', 'valide', 'diffuse'].map(statut => (
          <button
            key={statut}
            onClick={() => setFilterStatut(statut)}
            style={{
              padding: '6px 14px',
              borderRadius: 20,
              fontSize: 11,
              cursor: 'pointer',
              fontWeight: 600,
              background: filterStatut === statut ? 'rgba(201,168,76,0.2)' : 'rgba(255,255,255,0.05)',
              border: filterStatut === statut ? '1px solid #C9A84C' : '1px solid rgba(255,255,255,0.1)',
              color: filterStatut === statut ? '#C9A84C' : '#889'
            }}
          >
            {statut === '' ? 'Tous' : statut.charAt(0).toUpperCase() + statut.slice(1)}
          </button>
        ))}
      </div>

      {/* Liste des PV */}
      <div style={{ display: 'grid', gap: 12 }}>
        {loading && (
          <div style={{ padding: 40, textAlign: 'center', color: '#C9A84C' }}>
            Chargement...
          </div>
        )}

        {!loading && pvsFiltres.length === 0 && (
          <div style={{ padding: 40, textAlign: 'center', color: '#667' }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>📋</div>
            <div style={{ fontSize: 14 }}>Aucun procès-verbal</div>
          </div>
        )}

        {pvsFiltres.map(pv => (
          <div
            key={pv.id}
            style={{
              background: '#111f2e',
              border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: 11,
              padding: 16,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onClick={() => setSelectedPv(pv.id === selectedPv ? null : pv.id)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                  <h3 style={{ fontSize: 15, fontWeight: 600, color: '#fff', margin: 0 }}>
                    {pv.titre}
                  </h3>
                  {getStatutBadge(pv.statut)}
                </div>
                <div style={{ fontSize: 11, color: '#889' }}>
                  Réunion du {fmtDate(pv.date_reunion)} · Rédigé le {fmtDate(pv.date_redaction)}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                {pv.statut === 'brouillon' && (
                  <>
                    <button
                      onClick={(e) => { e.stopPropagation(); handleOpenModal(pv); }}
                      style={{ background: 'none', border: 'none', color: '#C9A84C', cursor: 'pointer', fontSize: 14, padding: '4px 8px' }}
                      title="Modifier"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={(e) => { e.stopPropagation(); handleValider(pv.id); }}
                      style={{ background: 'none', border: 'none', color: '#4caf50', cursor: 'pointer', fontSize: 14, padding: '4px 8px' }}
                      title="Valider"
                    >
                      ✓
                    </button>
                    <button
                      onClick={(e) => { e.stopPropagation(); handleDelete(pv.id); }}
                      style={{ background: 'none', border: 'none', color: '#ef5350', cursor: 'pointer', fontSize: 14, padding: '4px 8px' }}
                      title="Supprimer"
                    >
                      🗑️
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Détails dépliables */}
            {selectedPv === pv.id && (
              <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                {/* Résumé */}
                {pv.resume && (
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 10, color: '#C9A84C', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6, fontWeight: 600 }}>
                      Résumé
                    </div>
                    <div style={{ fontSize: 12, color: '#ccc', lineHeight: 1.6 }}>
                      {pv.resume}
                    </div>
                  </div>
                )}

                {/* Décisions */}
                {pv.decisions && pv.decisions.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 10, color: '#C9A84C', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, fontWeight: 600 }}>
                      Décisions ({pv.decisions.length})
                    </div>
                    {pv.decisions.map((decision, idx) => (
                      <div key={idx} style={{ marginBottom: 8, paddingLeft: 12, borderLeft: '2px solid #C9A84C55' }}>
                        <div style={{ fontSize: 12, color: '#fff' }}>{decision.texte || decision}</div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Observations Chef Département Caisse */}
                {pv.observations_rh && (
                  <div style={{ marginBottom: 16, background: 'rgba(201,168,76,0.08)', padding: 12, borderRadius: 8, border: '1px solid rgba(201,168,76,0.2)' }}>
                    <div style={{ fontSize: 10, color: '#C9A84C', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6, fontWeight: 600 }}>
                      💵 Observations du Chef Département Caisse
                    </div>
                    <div style={{ fontSize: 12, color: '#ccc', lineHeight: 1.6 }}>
                      {pv.observations_rh}
                    </div>
                  </div>
                )}

                {/* Observations DG */}
                {pv.observations_dg && (
                  <div style={{ background: 'rgba(255,152,0,0.08)', padding: 12, borderRadius: 8, border: '1px solid rgba(255,152,0,0.2)' }}>
                    <div style={{ fontSize: 10, color: '#ff9800', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6, fontWeight: 600 }}>
                      👔 Observations du Directeur Général
                    </div>
                    <div style={{ fontSize: 12, color: '#ccc', lineHeight: 1.6 }}>
                      {pv.observations_dg}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div 
          style={{ 
            position: 'fixed', 
            inset: 0, 
            background: 'rgba(0,0,0,.75)', 
            zIndex: 1000, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: 20,
            overflowY: 'auto'
          }} 
          onClick={handleCloseModal}
        >
          <div 
            style={{ 
              background: '#162535', 
              border: '1px solid rgba(255,255,255,.12)', 
              borderRadius: 14, 
              padding: 28, 
              minWidth: 600, 
              maxWidth: 800, 
              width: '90%',
              maxHeight: '90vh',
              overflowY: 'auto'
            }} 
            onClick={e => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
              <span style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>
                {editingId ? 'Modifier le PV' : 'Nouveau Procès-Verbal'}
              </span>
              <button 
                onClick={handleCloseModal} 
                style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}
              >
                ×
              </button>
            </div>

            {/* Formulaire */}
            <div style={{ display: 'grid', gap: 16 }}>
              {/* Titre */}
              <div>
                <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', display: 'block', marginBottom: 5, letterSpacing: 0.5 }}>
                  Titre *
                </label>
                <input
                  type="text"
                  value={formData.titre}
                  onChange={e => setFormData({ ...formData, titre: e.target.value })}
                  style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontSize: 13, outline: 'none' }}
                  placeholder="Ex: PV Réunion mensuelle Caisse"
                />
              </div>

              {/* Dates */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', display: 'block', marginBottom: 5, letterSpacing: 0.5 }}>
                    Date de réunion *
                  </label>
                  <input
                    type="date"
                    value={formData.date_reunion}
                    onChange={e => setFormData({ ...formData, date_reunion: e.target.value })}
                    style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontSize: 13, outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', display: 'block', marginBottom: 5, letterSpacing: 0.5 }}>
                    Date de rédaction *
                  </label>
                  <input
                    type="date"
                    value={formData.date_redaction}
                    onChange={e => setFormData({ ...formData, date_redaction: e.target.value })}
                    style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontSize: 13, outline: 'none' }}
                  />
                </div>
              </div>

              {/* Résumé */}
              <div>
                <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', display: 'block', marginBottom: 5, letterSpacing: 0.5 }}>
                  Résumé de la réunion
                </label>
                <textarea
                  value={formData.resume}
                  onChange={e => setFormData({ ...formData, resume: e.target.value })}
                  rows={4}
                  style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontSize: 13, outline: 'none', fontFamily: 'inherit', resize: 'vertical' }}
                  placeholder="Résumé des points abordés..."
                />
              </div>

              {/* Observations Chef Département Caisse */}
              <div style={{ background: 'rgba(201,168,76,0.05)', padding: 16, borderRadius: 8, border: '1px solid rgba(201,168,76,0.15)' }}>
                <label style={{ fontSize: 10, color: '#C9A84C', textTransform: 'uppercase', display: 'block', marginBottom: 8, letterSpacing: 0.5, fontWeight: 600 }}>
                  💵 Observations du Chef Département Caisse
                </label>
                <textarea
                  value={formData.observations_caisse}
                  onChange={e => setFormData({ ...formData, observations_caisse: e.target.value })}
                  rows={4}
                  style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(201,168,76,.2)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontSize: 13, outline: 'none', fontFamily: 'inherit', resize: 'vertical' }}
                  placeholder="Observations spécifiques du département Caisse..."
                />
              </div>

              {/* Observations DG */}
              <div style={{ background: 'rgba(255,152,0,0.05)', padding: 16, borderRadius: 8, border: '1px solid rgba(255,152,0,0.15)' }}>
                <label style={{ fontSize: 10, color: '#ff9800', textTransform: 'uppercase', display: 'block', marginBottom: 8, letterSpacing: 0.5, fontWeight: 600 }}>
                  👔 Observations du Directeur Général
                </label>
                <textarea
                  value={formData.observations_dg}
                  onChange={e => setFormData({ ...formData, observations_dg: e.target.value })}
                  rows={4}
                  style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,152,0,.2)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontSize: 13, outline: 'none', fontFamily: 'inherit', resize: 'vertical' }}
                  placeholder="Observations du Directeur Général..."
                />
              </div>

              {/* Boutons */}
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                <button 
                  onClick={handleCloseModal}
                  style={{ background: 'none', border: '1px solid rgba(255,255,255,.15)', borderRadius: 7, padding: '7px 16px', color: '#889', fontSize: 12, cursor: 'pointer' }}
                >
                  Annuler
                </button>
                <button 
                  onClick={handleSubmit}
                  style={{ background: 'linear-gradient(135deg,#C9A84C,#8a6028)', border: 'none', borderRadius: 7, padding: '7px 16px', color: 'white', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                >
                  {editingId ? 'Mettre à jour' : 'Créer le PV'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
